export default __webpack_public_path__ + "static/media/safexpress.12a05fae.png";